import { useContext } from "react";
import AuthContext from "../providers/auth.context";

function useAuth() {
  return useContext(AuthContext);
}

export default useAuth;
